<template>
  <div>
    <logo-vue :configData="configData"></logo-vue>
   </div>
</template>

<script>
import LogoVue from "./logo";
export default {
  props: ["configData"],
  components: {
    LogoVue
  }
};
</script>



// WEBPACK FOOTER //
// src/views/saftySetting/saftySettingHead/index.vue